import * as Scrivito from "scrivito";

const FormPageWidget = Scrivito.provideWidgetClass("FormPageWidget", {
  attributes: {
    headline: "string",
    inputs: [
      "widgetlist",
      {
        only: [
          "InputWidget",
          "SelectboxWidget",
          "RadioboxWidget",
          "TextAreaWidget",
          "CheckboxWidget",
          "ReceiverEmailInputWidget",
        ],
      },
    ],
  },
  onlyInside: ["FormWidget"],
});
export default FormPageWidget;
